import { mccs_charge_payment_type } from '@/@types/generated'
import { register, titleCaseFromSnakeCase } from './enum'

// Labels for mccs_charge_codes.payment_type (see db/migrations/V0308) — the "Applies To"
// cell's type badge (e.g. "Penalty", "New Vehicle"). Falls back to the shared snake_case ->
// Title Case rule for any value without an override.
const CHARGE_TYPE_LABEL_OVERRIDES: Partial<
  Record<mccs_charge_payment_type, string>
> = {
  [mccs_charge_payment_type.RE_REGISTERED_VEHICLE]: 'Re-Registered Vehicle',
}

register<mccs_charge_payment_type>(mccs_charge_payment_type, (v) => {
  if (!v) return '—'
  return CHARGE_TYPE_LABEL_OVERRIDES[v] ?? titleCaseFromSnakeCase(v)
})

// Distinct badge color per payment_type, one hue each (see ChameleonMatchType.ts for the
// same raw-Tailwind-palette convention) so charge types are visually distinguishable at a
// glance in the "Applies To" cell and the payment detail dialog's charge cards.
export const ChargePaymentTypeClassNames: Record<
  mccs_charge_payment_type,
  string
> = {
  [mccs_charge_payment_type.PENALTY]: 'bg-red-100 text-red-900 border-red-200',
  [mccs_charge_payment_type.NEW_APPLICATION]:
    'bg-blue-100 text-blue-900 border-blue-200',
  [mccs_charge_payment_type.BROKER_REGISTRATION]:
    'bg-purple-100 text-purple-900 border-purple-200',
  [mccs_charge_payment_type.NEW_VEHICLE]:
    'bg-green-100 text-green-900 border-green-200',
  [mccs_charge_payment_type.RENEWAL]:
    'bg-teal-100 text-teal-900 border-teal-200',
  [mccs_charge_payment_type.RE_REGISTERED_VEHICLE]:
    'bg-amber-100 text-amber-900 border-amber-200',
  [mccs_charge_payment_type.VEHICLE_ADDITION]:
    'bg-cyan-100 text-cyan-900 border-cyan-200',
  [mccs_charge_payment_type.INSURANCE]:
    'bg-indigo-100 text-indigo-900 border-indigo-200',
}
